export const mutations = {
  STORE_ACCOUNTTYPES(state, accounttypes) {
    state.accounttypes = accounttypes;
  },
  STORE_ACCOUNTTYPE_UPDATE(state, accounttypeId) {
    let Accounttype = state.accounttypes.find(function(accounttype) {
      return accounttype.id === accounttypeId;
    });
    state.systemAccounttype = Accounttype;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/accounttypes/mutations.js